var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3736_147823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3736_147823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 18.3346C9.54427 18.3346 9.15191 18.1714 8.82552 17.8451C8.49913 17.5187 8.33594 17.1263 8.33594 16.668H11.6693C11.6693 17.1263 11.5061 17.5187 11.1797 17.8451C10.8533 18.1714 10.4609 18.3346 10.0026 18.3346ZM3.33594 15.8346V14.168H5.0026V8.33464C5.0026 7.18186 5.34983 6.15755 6.04427 5.26172C6.73872 4.36589 7.64149 3.77908 8.7526 3.5013V2.91797C8.7526 2.57075 8.87413 2.27561 9.11719 2.03255C9.36024 1.7895 9.65538 1.66797 10.0026 1.66797C10.3498 1.66797 10.645 1.7895 10.888 2.03255C11.1311 2.27561 11.2526 2.57075 11.2526 2.91797V3.5013C11.4054 3.54297 11.5547 3.58811 11.7005 3.63672C11.8464 3.68533 11.9887 3.74436 12.1276 3.8138L10.8151 5.10547C10.6762 5.07769 10.5443 5.05339 10.4193 5.03255C10.2943 5.01172 10.1554 5.0013 10.0026 5.0013C9.08594 5.0013 8.30122 5.32769 7.64844 5.98047C6.99566 6.63325 6.66927 7.41797 6.66927 8.33464V14.168H13.3359V12.418L15.0026 10.7513V14.168H16.6693V15.8346H3.33594ZM10.0026 10.8346V8.27214L14.6068 3.6888C14.7318 3.5638 14.8707 3.47352 15.0234 3.41797C15.1762 3.36241 15.329 3.33464 15.4818 3.33464C15.6484 3.33464 15.8082 3.36589 15.9609 3.42839C16.1137 3.49089 16.2526 3.58464 16.3776 3.70964L17.1484 4.48047C17.2596 4.60547 17.3464 4.74436 17.4089 4.89714C17.4714 5.04991 17.5026 5.20269 17.5026 5.35547C17.5026 5.50825 17.4748 5.6645 17.4193 5.82422C17.3637 5.98394 17.2734 6.1263 17.1484 6.2513L12.5651 10.8346H10.0026ZM11.2526 9.58464H12.0443L14.5651 7.04297L14.1901 6.64714L13.7943 6.27214L11.2526 8.79297V9.58464ZM14.1901 6.64714L13.7943 6.27214L14.5651 7.04297L14.1901 6.64714Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconWhite);
export default __webpack_public_path__ + "static/media/NotificationIconWhite.2f4adb6c618f89fdf483203100547f60.svg";
export { ForwardRef as ReactComponent };